import { useQuery } from "@tanstack/react-query";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MessageSquareText } from "lucide-react";
import { messageTemplateService } from "@/services/messageTemplate";
import { MessageTemplatesTab } from "@/components/templates/MessageTemplatesTab";
import { BillingRulesTab } from "@/components/billing-rules/BillingRulesTab";
import { MessageLogsTab } from "@/components/message-logs/MessageLogsTab";
import { WhatsAppConnectionTab } from "@/components/whatsapp/WhatsAppConnectionTab";

export function MessagingCard() {
  const { data: templatesData, isLoading: loadingTemplates } = useQuery({
    queryKey: ["message-templates"],
    queryFn: () => messageTemplateService.getAll({ limit: 100 }),
  });

  const templates = templatesData?.data ?? [];

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          <MessageSquareText className="w-4 h-4 text-primary" />
          Mensajería
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Tabs defaultValue="whatsapp">
          <TabsList>
            <TabsTrigger value="whatsapp">WhatsApp</TabsTrigger>
            <TabsTrigger value="templates">Plantillas</TabsTrigger>
            <TabsTrigger value="rules">Reglas de envío</TabsTrigger>
            <TabsTrigger value="logs">Historial de envíos</TabsTrigger>
          </TabsList>
          <TabsContent value="whatsapp">
            <WhatsAppConnectionTab />
          </TabsContent>
          <TabsContent value="templates">
            <MessageTemplatesTab templates={templates} isLoading={loadingTemplates} />
          </TabsContent>
          <TabsContent value="rules">
            <BillingRulesTab templates={templates} />
          </TabsContent>
          <TabsContent value="logs">
            <MessageLogsTab />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
}
